<div class="view-all-notification-modal">
    <div class="modal-header">
        <div class="modal-title-container">
            <span class="modal-icon">
                <img src="../../../../../../assets/images/client-messaging/bellWithRedDot.svg"
                    alt="Notifications Icon" />
            </span>
            <div class="title">Notifications</div>
        </div>
        <button class="close-button" (click)="onCancel()" aria-label="Close">
            <img src="../../../../../../assets/images/client-messaging/cross.svg" alt="Close" />
        </button>
    </div>

    <div class="modal-body">
        <div class="container-wrapper">
            <div class="dropdowns-container">
                <!-- Viewing Dropdown with ng-select -->
                <div class="dropdown-group">
                    <label for="viewingSelect" class="sr-only">Viewing Options</label>
                    <ng-select id="viewingSelect" [(ngModel)]="selectedViewing" (change)="onViewingChange($event)"
                        class="select-style" [items]="viewingOptions" bindLabel="label" bindValue="value"
                        [multiple]="false" [searchable]="false" [clearable]="false"
                        placeholder="Viewing: Select an option">
                        <!-- Custom template for the selected value (single-select) -->
                        <ng-template ng-label-tmp let-item="item">
                            <div class="custom-selected-value">
                                Viewing: <span class="highlight">{{ item.label }}</span>
                            </div>
                        </ng-template>
                        <!-- Custom template for dropdown options -->
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option">
                                {{ item.label }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <!-- Sort By Dropdown with ng-select -->
                <div class="dropdown-group">
                    <label for="sortSelect" class="sr-only">Sort By Options</label>
                    <ng-select id="sortSelect" [(ngModel)]="selectedSort" (change)="onSortChange($event)"
                        class="select-style" [items]="sortOptions" bindLabel="label" bindValue="value"
                        [multiple]="false" [searchable]="false" [clearable]="false"
                        placeholder="Sort By: Select an option">
                        <!-- Custom template for the selected value (single-select) -->
                        <ng-template ng-label-tmp let-item="item">
                            <div class="custom-selected-value">
                                Sort By: <span class="highlight">{{ item.label }}</span>
                            </div>
                        </ng-template>
                        <!-- Custom template for dropdown options -->
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option">
                                {{ item.label }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <!-- Refresh Button -->
                <div class="refresh" (click)="refreshNotifications()">
                    <i class="fa fa-refresh" aria-hidden="true" height="20" width="20"></i>
                </div>
            </div>

            <!-- Notification Text -->
            <p class="notification-text">Notifications available of past 5 days only.</p>
        </div>
        <div class="notification-list" [appLoading]="isLoading" >
            <div *ngIf="notifications.length === 0" class="no-notifications">
                <div class="col-sm-12" style="padding: 20px 15px; margin-bottom: 20px; text-align: center;">
                    <img src="../../../../../assets/images/Upfront Icon/Empty1.svg" style="width: 80px;" />
                    <p style="color: #75787B; font-size: 20px; margin-top: 20px;">
                        No notifications.
                    </p>
                </div>
            </div>
            <div *ngFor="let notification of notifications" class="notification-item" [class.read]="notification.read" (click)="openMyConversation(notification.patientId)" >
                <img [src]="notification.type === 'follow' ? '/assets/images/client-messaging/FollowerAdded.svg' :notification.user.avatar" alt="User Avatar" class="notification-avatar" />
                <div class="notification-content">
                    <div class="notification-meta">
                        <span class="notification-user-name">{{ notification.type === 'follow' ? 'Follow' : notification.user.name }}</span>
                        <span class="notification-type" *ngIf="notification.type === 'incoming_sms'">Incoming Text</span>
                        <span class="notification-type" *ngIf="notification.type === 'incoming_email'">Incoming Email</span>
                        <span class="notification-type" *ngIf="notification.type === 'follow'">Follower Added</span>
                    </div>
                    <p class="notification-message" *ngIf="notification.message">
                        <span *ngIf="notification.type === 'incoming_email'" class="font-medium" >Subject:
                            <span [innerHTML]="
                            notification.subject && notification.subject.length > 30
                            ? (notification.subject | slice: 0:30) + '...'
                            : notification.subject
                            "></span>
                         </span>
                        <span class="message" [innerHTML]=" notification.message.length > 60 ? (notification.message | slice: 0:60) + '...': notification.message"></span>
                    </p> 
                    <div class="message attachment-preview" *ngIf="notification.hasMMSAttachment && !notification.message">
                        <i class="fa fa-paperclip attachment-icon"></i>
                        <span>Attachment</span>
                        </div>
                    <span class="notification-time">{{ notification.timeAgo }}</span>
                </div>
                <span class="notification-time">
                    <img src="/assets/images/client-messaging/time.svg" alt="Time icon" />
                    {{ notification.timeAgo }}
                </span>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <span class="page-info" *ngIf="notifications.length !== 0">Showing
            {{ (paginationConfig.currentPage - 1) * itemsPerPage + 1 }} to
            {{
            paginationConfig.currentPage * itemsPerPage > totalItems
            ? totalItems
            : paginationConfig.currentPage * itemsPerPage
            }}
            of {{ totalItems }} entries</span>
        <app-pagination [config]="paginationConfig" [total]="totalItems" [limit]="itemsPerPage"
            [pageObject]="pageObject" (pageChange)="onPageChange($event)" [custompageInfo]="false">
        </app-pagination>
    </div>
</div>